<template>
  <div class="carousel" :style="overlayBgStyle">
    <div class="close-button">
      <q-btn icon="close" flat round dense @click="$emit('closeSlider')" />
      <ReturnHomeButton @click="$emit('closeAllDialogs')" />
    </div>
    <div class="container">
      <q-carousel  style="transform: translate(0, 10%); width:95%; margin:auto;" v-model="slide" height="85%"  transition-prev="slide-right" transition-next="slide-left" swipeable animated
        control-color="black" navigation padding arrows class="bg-grey-1 shadow-2 rounded-borders">
        <q-carousel-slide v-for="(slides, index) in chunks" :key="index" :name="index">
          <div class="row fit justify-start items-center q-gutter-xs q-col-gutter no-wrap">
            <div class="image-container" v-for="(slide, slideIndex) in slides.filter(s => s !== null)" :key='slideIndex'>
              <img
                :src="slide"
                class="carousel-image"
                :style="{ 'animation-delay': `${slideIndex * 0.5}s` }" />
            </div>
          </div>
        </q-carousel-slide>
      </q-carousel>
    </div>

  </div>
</template>
  
<script>
import axios from 'axios';
import { onMounted, ref } from 'vue';
import ReturnHomeButton from './ReturnHomeButton.vue';
import { useOverlayBg } from '../composables/useOverlayBg';
export default {
  components: { ReturnHomeButton },
  props: ['blockDatas'],
  setup(props) {
    const blocks = ref([]);
    const chunks = ref([])
    var resources = ref([]);
    var slide = ref(0);

    const fetchResources = async () => {
      try {
        const associatedResources = props.blockDatas.associatedResources;
        let resourcesTemp = [];
        
        // Récupérer toutes les ressources avec leur index
        for (let i = 0; i < associatedResources.length; i++) {
          const resource = associatedResources[i];
          const url = `${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`;
          let response = await axios.get(url);
          
          // Ajouter l'index à chaque ressource (utiliser l'index existant ou sa position)
          resourcesTemp.push({
            url: response.data,
            index: resource.index !== undefined ? resource.index : i
          });
        }
        
        // Trier les ressources par index
        resourcesTemp.sort((a, b) => a.index - b.index);
        
        // Extraire uniquement les URLs des ressources triées
        resources.value = resourcesTemp.map(item => item.url);
        
        // Grouper les ressources triées
        groupResources();
      } catch (error) {
        console.error(error);
      }
    }



    const groupResources = () => {
      const size = 3;
      const array = resources.value;

      let chunk = [];
      for (let i = 0; i < array.length; i++) {
        if (chunk.length === 0 && i < size) {
          chunk.push(array[i]);
          if (i === size - 1 || i === array.length - 1) {
            chunks.value.push(chunk);
            chunk = [];
          }
        } else {
          chunk.push(array[i]);
          if (chunk.length === size) {
            chunks.value.push(chunk);
            chunk = [];
          }
        }
      }

      if (chunk.length > 0) {
        while (chunk.length < size) {
          chunk.push(null);
        }
        chunks.value.push(chunk);
      }
    };




    onMounted(() => {
      //groupResources();
      fetchResources();

    });

    const { overlayBgStyle } = useOverlayBg();

    return {
      overlayBgStyle,
      blocks,
      chunks,
      resources,
      groupResources,
      slide
    };
  }
};
</script>
  
<style scoped>
.carousel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(217, 217, 217, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.container{
  height: 100vh;
  width: 100vw;
  vertical-align: center;
}

.close-button{
  transform: translate(50%, 150%);
}

.image-container {
  height: 280px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0 10px;
}

.carousel-image {
  height: 280px !important;
  width: auto !important;
  max-width: none;
  border-radius: 8px;
  background: #f5f5f5;
  padding: 10px;
  display: block;
  box-sizing: border-box;
}
</style>
  